var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qd-button',{class:[
      _vm.classButton,
      'mgr-0',
      {
        'double-sticky-button-right': _vm.actions.length,
        'button-access-no-permission pointer-events-none': _vm.disabled,
      }
    ],attrs:{"type":_vm.type},on:{"click":function($event){_vm.checkAllPermissions(_vm.permission) ? _vm.$emit('click') : _vm.showPopUp}}},[_vm._t("default")],2),(_vm.actions.length > 0)?_c('b-dropdown',{staticClass:"is-relative",class:{'pointer-events-none': _vm.disabled},attrs:{"aria-role":"list","position":_vm.position},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('qd-button',{class:[
          _vm.classButton,
          'mgv-0 double-sticky-button-left',
          {
            'double-sticky-button-right': _vm.actions.length,
            'button-access-no-permission pointer-events-none': _vm.disabled,
          }
        ],attrs:{"type":_vm.type}},[_c('b-icon',{staticClass:"mgt-1",attrs:{"icon":"chevron-down"}})],1)]},proxy:true}],null,false,995193449)},_vm._l((_vm.sortedActions()),function(item,index){return _c('b-dropdown-item',{key:index,attrs:{"aria-role":"listitem","disabled":!!item.disabled},on:{"click":function () {
        _vm.checkAllPermissions(item.permissionAction) ? item.action() : _vm.showPopUp;
      }}},[_c('b-tooltip',{attrs:{"active":!!item.disabled && !!item.tooltip,"label":item.tooltip,"type":"is-primary","position":"is-left"}},[_c('span',[_vm._v(_vm._s(item.label))])])],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }